import React from "react";
import loadable from "@loadable/component";
import CenterSpinner from "../../common/centerSpinner";

function AsyncProfilePage({ ...rest }) {
  const AsyncLoad = loadable(() => import("../page/profile"));
  console.log("Loading", AsyncProfilePage.name);
  return <AsyncLoad {...rest} fallback={<CenterSpinner />} />;
}

export default AsyncProfilePage;
